
import './Home.css';

const Home = () => {

    return <div className="App">
      <header className="App-header">
        <h2>Home of all apps created by Austin Binish</h2>
        <div className="app-links">
          <a href="/fantasy-preview" target="_blank" rel="noopener noreferrer">
            Fantasy Football Preview 2025
          </a>
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </div>
        </header>
        </div>;
}
export default Home;